<template>
  <div
    class="event-ticket"
    :class="{ active, type, col1, disabled, 'no-info': noInfo }"
  >
    <button class="toggle" @click="noInfo ? null : (active = !active)">
      <div class="date" v-if="icon === '' && date !== '' && date !== null">
        {{
          format(
            new Date(props.date.replace(/-/g, "/") + " 00:00:01"),
            "MMM dd,yyyy"
          )
        }}
      </div>
      <div class="date" v-else-if="showTBD">TBD</div>
      <div class="info">
        <div class="icon" v-if="icon !== ''">
          <img :src="`${$store.state.ASSET_URL}${icon}`" alt="" />
          <div class="date" v-if="date !== '' && date !== null">
            {{
              format(
                new Date(props.date.replace(/-/g, "/") + " 00:00:01"),
                "MMM dd"
              )
            }}
          </div>
        </div>
        <svg
          class="arrow"
          width="8"
          height="14"
          viewBox="0 0 8 14"
          xmlns="http://www.w3.org/2000/svg"
          v-if="!noInfo"
        >
          <path d="M0.226562 14L7.22656 7L0.226562 0V14Z" />
        </svg>
        <div class="game">
          <p class="title">{{ title }}</p>
          <p v-if="disabled" class="subtitle">Reached Capacity</p>
        </div>
        <div class="image" v-if="image !== ''">
          <img :src="`${$store.state.ASSET_URL}${image}`" alt="" />
        </div>
      </div>
    </button>
    <transition
      mode="out-in"
      @before-enter="beforeEnter"
      @enter="enter"
      @after-enter="afterEnter"
      @before-leave="beforeLeave"
      @leave="leave"
      @after-leave="afterLeave"
    >
      <div class="description" v-show="active">
        <div>
          <p v-if="isHtml" v-html="description" />
          <p v-else>{{ description }}</p>
          <button
            class="buy-now"
            v-if="!link?.includes('https') && link !== ''"
            type="button"
            :data-fevo-offer-id="link"
          >
            {{ label }}
          </button>
          <a
            v-else-if="link !== ''"
            class="buy-now"
            target="_blank"
            :href="link"
            @click.stop
            >{{ label }}</a
          >
        </div>
      </div>
    </transition>
  </div>
</template>

<script setup>
import { ref } from "vue";
import { format } from "date-fns";
const props = defineProps({
  title: String,
  type: String,
  showTBD: Boolean,
  noInfo: Boolean,
  col1: Boolean,
  date: {
    type: String,
    default: "",
  },
  time: String,
  link: {
    type: String,
    default: "",
  },
  icon: {
    type: String,
    default: "",
  },
  image: {
    type: String,
    default: "",
  },
  description: {
    type: String,
    default: "",
  },
  label: {
    type: String,
    default: "Buy Now",
  },
  isHtml: Boolean,
  disabled: Boolean,
  fevo: Boolean,
});
const active = ref(0);
function beforeEnter(el) {
  el.style.height = 0;
  el.parentElement.style.zIndex = "";
}
function enter(el) {
  el.style.height = el.scrollHeight + "px";
  el.parentElement.style.zIndex = "1";
}
function afterEnter(el) {
  //el.style.height = "auto";
}

function beforeLeave(el) {
  el.style.height = el.scrollHeight + "px";
  el.parentElement.style.zIndex = "1";
}
function leave(el) {
  el.style.height = "0px";
}
function afterLeave(el) {
  el.parentElement.style.zIndex = "";
}
</script>

<style lang="scss" scoped>
.disabled {
  filter: saturate(0);
  pointer-events: none;
  * {
    opacity: 0.8;
  }
  .info .game {
    padding: 17px 0;
  }
}
.event-ticket {
  background-color: #fff;
  user-select: none;
  border-bottom-left-radius: 10px;
  border-top-right-radius: 10px;
  overflow: hidden;
  transition: all 0.5s;
  &.col1 {
    width: calc(50% - 5px);
    @media (max-width: 1000px) {
      width: 100%;
    }
  }
  &.no-info {
    padding: 0 1rem;
    .toggle {
      user-select: none;
      cursor: default;
    }
  }
  .toggle {
    display: flex;
    color: #54585a;
    width: 100%;
    align-items: stretch;
    text-align: left;
    background: none;
    border: none;
  }
  @media (hover: hover) {
    &:hover {
      transform: translateX(10px);
      box-shadow: 0px 10px 25px rgba(0, 0, 0, 0.2);
      .toggle {
        color: #0076b6;
      }
      .arrow {
        fill: #0076b6;
      }
    }
    &.active {
      .arrow {
        transform: rotateZ(270deg);
      }
    }
  }
}
.description {
  font-family: "PF DinDisplay Pro";
  font-weight: 500;
  font-size: 0.875rem;
  line-height: 1.43;
  color: #54585a;
  transition: height 0.5s;
  position: relative;
  > div {
    padding: 30px 15px;
  }
  &:before {
    content: "";
    background-image: url("~@/assets/images/grunge.png");
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    opacity: 0.1;
    pointer-events: none;
  }
  p {
    margin-bottom: 15px;
  }
}
.date {
  font-family: "United Sans Cd Hv";
  font-weight: 900;
  transition: all 0.5s;
  background: rgba(#bbbbbb, 0.4);
  text-transform: uppercase;
  text-align: center;
  color: #0076b6;
  line-height: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 7px;
  width: 90px;
  flex-shrink: 0;
  font-size: 1rem;
}
.info {
  display: flex;
  position: relative;
  overflow: hidden;
  gap: 8px;
  flex-grow: 1;
  align-items: center;
  @media (min-width: 400px) {
    gap: 20px;
  }
  .image {
    position: static;
    top: 0;
    right: -25px;
    width: 35%;
    height: 100%;
    pointer-events: none;
    max-width: 220px;
    background: #bbbbbb;
    transform: skewX(-25deg);
    overflow: hidden;
    position: absolute;
    img {
      transform: skewX(25deg) translateX(-25px);
      width: 100%;
      object-fit: cover;
      position: relative;
      //right:5px;
    }
  }
  &:before {
    content: "";
    background-image: url("~@/assets/images/grunge.png");
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    opacity: 0.1;
    pointer-events: none;
  }
  > div {
    box-sizing: border-box;
    display: flex;
  }
  .icon {
    padding: 0 25px;
    flex-shrink: 0;
    align-items: center;

    .date {
      background: none;
      position: absolute;
      bottom: 3px;
      left: 0;
    }
    img {
      width: 40px;
      height: 40px;
      flex-shrink: 0;
    }
  }
  .game {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: center;
    padding: 0;
    height: 98px;
    flex-grow: 1;
    .title {
      max-width: calc(65% - 25px);
    }
  }
  .reached-capacity .game {
    padding: 0 25px;
  }
  p {
    margin: 0;
    font-family: "United Sans Cd Bd";
    font-weight: bold;
    font-size: 1.5rem;
    line-height: 1;
    text-transform: uppercase;
  }
  .subtitle {
    font-size: 1rem;
  }
}
.buy-now {
  font-family: "United Sans Cd Bd";
  font-weight: bold;
  padding: 5px 20px;
  background: #0076b6;
  border-bottom-left-radius: 10px;
  border-top-right-radius: 10px;
  color: #fff;
  font-size: 1.5rem;
  line-height: 1;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  transition: all 0.5s;
  &:hover {
    background: linear-gradient(0deg, rgba(0, 0, 0, 0.2), rgba(0, 0, 0, 0.2)),
      #0076b6;
  }
}
.arrow {
  transition: all 0.5s;
  fill: #54585a;
  transform: rotateZ(90deg);
}
.non-gameday {
  .arrow {
    margin: 0 25px;
  }
}
</style>
